module.exports = __webpack_public_path__ + "./docs/img/icon-rocket.a0d888ecb018b17617efaf9786ff271f.svg";